import {
  downloadExportGridFromProjectToIRAPApi,
  downloadExportPolygonFromProjectToIRAPApi,
  fileExportFaultApi,
  fileExportHorizon2DApi,
  fileExportHorizon3DApi,
  get2DFileNameApi,
  get3DFileNameApi,
  getFaultFileNameApi,
  getFileNameGridFromProjectToIRAPApi,
  getFileNamePolygonFromProjectToIRAPApi,
} from '@core/core/api'
import type { ExportDataType, ObjectTreeNode, UseDownloadFilesReturnType } from '@core/core/types'
import type { ProjectId } from 'common/types'

// Скоро дерево будет @deprecated, но всё-таки лучше считать это хелпером, а не хуком
export const createExportHandler = (projectId: ProjectId): UseDownloadFilesReturnType => {
  const getData = (objectTreeNode?: ObjectTreeNode): ExportDataType | undefined => {
    const objectTreeNodeUid: string | undefined = objectTreeNode?.projectEntityUid
    if (!objectTreeNodeUid) return

    switch (objectTreeNode?.elementType) {
      case 'polygon':
        return {
          accept: {
            'irap/*': ['.irap'],
          },
          getFileBin: downloadExportPolygonFromProjectToIRAPApi(projectId, objectTreeNodeUid),
          getFileName: getFileNamePolygonFromProjectToIRAPApi(projectId, objectTreeNodeUid),
        }
      case 'fault':
        return {
          accept: {
            'chm/*': ['.chm'],
          },
          getFileBin: fileExportFaultApi(objectTreeNodeUid),
          getFileName: getFaultFileNameApi(objectTreeNodeUid),
          description: 'Charisma fault sticks (ASCII)',
        }
      case 'grid':
      case 'map':
        return {
          accept: {
            'irap/*': ['.irap'],
          },
          getFileBin: downloadExportGridFromProjectToIRAPApi(projectId, objectTreeNodeUid),
          getFileName: getFileNameGridFromProjectToIRAPApi(projectId, objectTreeNodeUid),
        }
      case 'interpretation3D':
        return {
          accept: {
            'chr/*': ['.chr'],
          },
          getFileBin: fileExportHorizon3DApi(objectTreeNodeUid),
          getFileName: get3DFileNameApi(objectTreeNodeUid),
          description: 'Charisma 3D interpretation lines (ASCII)',
        }
      case 'interpretation2D':
        return {
          accept: {
            'chr/*': ['.chr'],
          },
          getFileBin: fileExportHorizon2DApi(objectTreeNodeUid),
          getFileName: get2DFileNameApi(objectTreeNodeUid),
          description: 'Charisma 2D interpretation lines (ASCII)',
        }
      default: {
        return undefined
      }
    }
  }

  const handleExportFiles = async (objectTreeNode?: ObjectTreeNode) => {
    const data = getData(objectTreeNode)
    if (data) {
      const { getFileName, description, accept, getFileBin } = data
      const suggestedName = await getFileName
      const options = {
        suggestedName,
        types: [
          {
            description,
            accept,
          },
        ],
        excludeAcceptAllOption: true,
        multiple: false,
      }

      const newHandle = await window.showSaveFilePicker(options)
      const writable = await newHandle.createWritable()

      try {
        const byteReader = await getFileBin
        // Стрим автоматически закрывается, если результат .pipeTo - .fulfilled
        await byteReader.pipeTo(writable)
      } catch (e) {
        await writable.close()
        console.error('Файл не был экспортирован: ', e)
      }
    }
  }

  return handleExportFiles
}
